import { useFetch } from '../../../../hooks/useFetch';
import {
    getProspectUserPreferences,
    updateProspectUserPreferences
} from '../../../../api/ProspectUserProfile';
import React, { useState } from 'react';
import Col from 'reactstrap/lib/Col';
import LoadingOverlay from '../../../common/LoadingOverlay';
import Form from '../../../common/form/Form';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import PreferencesInputs, { allTourTypeOptions } from '../../../common/PreferencesInputs';
import Row from 'reactstrap/lib/Row';
import FormSelectLabeled from '../../../common/form/SelectLabeled';

const MyPreferencesPage = () => {
    const [wasFormValidated, setWasFormValidated] = useState<boolean>(false);
    const {
        data: preferences,
        setData: setPreferences,
        loading,
        setLoading,
        error,
        setError
    } = useFetch(getProspectUserPreferences, [], undefined);

    const onSubmit = async () => {
        if (!preferences) {
            return;
        }
        setLoading(true);

        let result = await updateProspectUserPreferences(preferences);

        if (result.success) {
            setLoading(false);
        } else {
            setError(result.error);
            setLoading(false);
        }
    };

    return (
        <Row>
            <Col xs={12} lg={{ offset: 2, size: 8 }}>
                <LoadingOverlay show={loading} inBootstrapColumn={true} />
                {preferences && (
                    <Form
                        wasFormValidated={wasFormValidated}
                        inBootstrapColumn={true}
                        submitButtonText={'Save'}
                        onSubmit={onSubmit}
                        onFormValidated={() => setWasFormValidated(true)}
                        additionalSubmitButtonClassname="btn-full-width"
                    >
                        <FormValidationDisplay errorMessage={error} />
                        <label className="prospect-guidance-header">My Preferences</label>
                        <PreferencesInputs
                            preferences={preferences}
                            setPreferences={setPreferences}
                        />

                        <FormSelectLabeled
                            selectProps={{
                                id: 'self-guided',
                                name: 'preferredTourFormat',
                                value: preferences.preferredTourFormat,
                                required: true,
                                placeholder: 'Select a tour type...'
                            }}
                            labelProps={{
                                labelText: 'Type of Tour',
                                invalidText: 'Please select a tour type'
                            }}
                            selectOptions={allTourTypeOptions}
                            onChange={(_name, value) =>
                                typeof value === 'number' &&
                                setPreferences({
                                    ...preferences,
                                    preferredTourFormat: value
                                })
                            }
                        />
                    </Form>
                )}
            </Col>
        </Row>
    );
};

export default MyPreferencesPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/account/MyPreferencesPage.tsx